import React, { useMemo, useState } from 'react';
import classNames from 'classnames';
import type { RestrictedUserIcon } from '../../stores/types/session';
import { RESTRICTED_USER_ICONS } from '../../stores/reducers/session';
import Icon, { COLORS } from '../general-components/icon';
import TooltipWrapper from '../general-components/tooltips/tooltip-wrapper';

interface Props {
	restrictedUserState?: number;
}

export default function RestrictedUserTooltip(props: Props) {
	const { restrictedUserState = 0 } = props;

	const [tooltipText, setTooltipText] = useState<string>('');

	const iconData = useMemo(() => {
		const nIconData = RESTRICTED_USER_ICONS.find(
			(icon: RestrictedUserIcon) => (icon.type === restrictedUserState),
		);

		setTooltipText(nIconData?.description ?? '');

		return nIconData;
	}, [restrictedUserState]);

	if (!iconData) {
		return (<></>);
	}

	return (
		<div className="restricted-user" data-testid="restricted-user-tooltip">
				<div className="width-full align-items-center justify-content-center">
					{iconData?.icons.map((icon: string, index: number) => (
						<TooltipWrapper message={tooltipText} key={index}>
							<div className={classNames('restricted-user-icon', index && 'margin-left-medium')}>
								<Icon name={icon} size={15} color={COLORS.WHITE} />
							</div>
						</TooltipWrapper>
					))}
				</div>
			</div>
	);
}
